import React from 'react';
import { connect } from 'react-redux';

import Header from 'components/organisms/Header';
import Footer from 'components/organisms/Footer';
import Loading from 'components/molecules/Loading';

const App = ({
	children,
	hideNavi,
	hideFooter,
	loading,
}) => (
	<div>
		{!hideNavi && <Header />}
		{children}
		{!hideFooter && <Footer />}
		<Loading active={loading} />
	</div>
);

const mapStateToProps = ({
	routing: { locationBeforeTransitions: { query: { source }, pathname } },
	global,
}) => ({
	hideNavi: pathname.includes('/forget') || source === 'app' || pathname === '/signup' || pathname === '/login' || pathname === '/oldlogin',
	hideFooter: pathname.includes('/forget') || source === 'app' || pathname === '/signup' || pathname === '/login' || pathname === '/oldlogin',
	loading: global.loading,
});

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/layouts/App/index.js